import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

import "echarts/map/js/china";

const PROVINCE_MAP: any = {};
PROVINCE_MAP["北京市"] = "北京";
PROVINCE_MAP["天津市"] = "天津";
PROVINCE_MAP["河北省"] = "河北";
PROVINCE_MAP["山西省"] = "山西";
PROVINCE_MAP["内蒙古自治区"] = "内蒙古";
PROVINCE_MAP["辽宁省"] = "辽宁";
PROVINCE_MAP["吉林省"] = "吉林";
PROVINCE_MAP["黑龙江省"] = "黑龙江";
PROVINCE_MAP["上海市"] = "上海";
PROVINCE_MAP["江苏省"] = "江苏";
PROVINCE_MAP["浙江省"] = "浙江";
PROVINCE_MAP["安徽省"] = "安徽";
PROVINCE_MAP["福建省"] = "福建";
PROVINCE_MAP["江西省"] = "江西";
PROVINCE_MAP["山东省"] = "山东";
PROVINCE_MAP["河南省"] = "河南";
PROVINCE_MAP["湖北省"] = "湖北";
PROVINCE_MAP["湖南省"] = "湖南";
PROVINCE_MAP["广东省"] = "广东";
PROVINCE_MAP["广西壮族自治区"] = "广西";
PROVINCE_MAP["四川省"] = "四川";
PROVINCE_MAP["贵州省"] = "贵州";
PROVINCE_MAP["云南省"] = "云南";
PROVINCE_MAP["西藏自治区"] = "西藏";
PROVINCE_MAP["陕西省"] = "陕西";
PROVINCE_MAP["甘肃省"] = "甘肃";
PROVINCE_MAP["青海省"] = "青海";
PROVINCE_MAP["宁夏回族自治区"] = "宁夏";
PROVINCE_MAP["新疆维吾尔自治区"] = "新疆";
PROVINCE_MAP["海南省"] = "海南";
PROVINCE_MAP["台湾省"] = "台湾";
PROVINCE_MAP["重庆市"] = "重庆";
PROVINCE_MAP["香港特别行政区"] = "香港";
PROVINCE_MAP["澳门特别行政区"] = "澳门";

function fixProvinceName(province: string) {
  return PROVINCE_MAP[province] || province;
}

function getValueFromMap(data: any, province: string) {
  return data[province] || 0;
}

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const data: any = {};
  let maxCount = 0;
  for (let j = 0; j < datas.rowCount; j++) {
    if (datas.rowDimNodes[j][0].total) {
      continue;
    }

    let count = 0;
    if (datas.dataValues[datas.rowColIndexes[j][0]]) {
      count = datas.dataValues[datas.rowColIndexes[j][0]][0];
    }
    if (count > maxCount) {
      maxCount = count;
    }

    const province = fixProvinceName(datas.rowDimNodes[j][0].label);
    data[province] = count;
  }

  const geoData = [
    { name: "北京", value: 0 },
    { name: "天津", value: 0 },
    { name: "上海", value: 0 },
    { name: "重庆", value: 0 },
    { name: "河北", value: 0 },
    { name: "河南", value: 0 },
    { name: "云南", value: 0 },
    { name: "辽宁", value: 0 },
    { name: "黑龙江", value: 0 },
    { name: "湖南", value: 0 },
    { name: "安徽", value: 0 },
    { name: "山东", value: 0 },
    { name: "新疆", value: 0 },
    { name: "江苏", value: 0 },
    { name: "浙江", value: 0 },
    { name: "江西", value: 0 },
    { name: "湖北", value: 0 },
    { name: "广西", value: 0 },
    { name: "甘肃", value: 0 },
    { name: "山西", value: 0 },
    { name: "内蒙古", value: 0 },
    { name: "陕西", value: 0 },
    { name: "吉林", value: 0 },
    { name: "福建", value: 0 },
    { name: "贵州", value: 0 },
    { name: "广东", value: 0 },
    { name: "青海", value: 0 },
    { name: "西藏", value: 0 },
    { name: "四川", value: 0 },
    { name: "宁夏", value: 0 },
    { name: "海南", value: 0 },
    { name: "台湾", value: 0 },
    { name: "香港", value: 0 },
    { name: "澳门", value: 0 },
  ];
  for (let i = 0; i < geoData.length; i++) {
    geoData[i].value = getValueFromMap(data, geoData[i].name);
  }

  const option: any = {
    tooltip: {},
    visualMap: {
      min: 0,
      max: maxCount,
      text: ["高", "低"],
      realtime: false,
      calculable: true,
      inRange: {
        color: ["#fffffe", "#006edd"],
      },
    },
    geo: {
      map: "china",
      roam: true,
      itemStyle: {
        normal: {
          borderColor: "rgba(0, 0, 0, 0.2)",
        },
        emphasis: {
          areaColor: null,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowBlur: 20,
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
    series: [
      {
        name: "申请量",
        type: "map",
        roam: true,
        coordinateSystem: "geo",
        geoIndex: 0,
        label: {
          normal: {
            formatter: "{b}",
            position: "right",
            show: false,
          },
          emphasis: {
            show: true,
          },
        },
        itemStyle: {
          normal: {
            color: "#F06C00",
          },
        },
        data: geoData,
      },
    ],
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {},
      },
    };
  }

  return option;
}
